import type React from 'react';
import { Route, Routes } from 'react-router-dom';

import { MessengerMainPage } from './mesenger-main-page';

export const Messenger: React.FC = () => {
	return (
		<Routes>
			<Route index element={<MessengerMainPage />} />
		</Routes>
	);
};
